var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{staticClass:"setting-container",attrs:{"placement":"right","closable":true,"maskClosable":true,"visible":_vm.visible,"zIndex":99999,"title":"配置中心"},on:{"close":_vm.onClose}},[_c('a-menu',{staticClass:"list"},_vm._l((_vm.manageCenterArr),function(item,index){return _c('a-menu-item',{key:index,class:{
        'list-disabled': item.status == 0,
        active: _vm.$route.path == item.path,
      }},[_c('router-link',{attrs:{"to":item.path}},[_c('img',{attrs:{"src":item.icon,"alt":"img"}}),_vm._v(" "+_vm._s(item.name)+" ")])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }